// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
	measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// const firebaseConfig = {
// 	apiKey: "AIzaSyBY7DkV03fSKCMkJWc8G0X3e-so_VPuIXk",
// 	authDomain: "happyasciicat.firebaseapp.com",
// 	projectId: "happyasciicat",
// 	storageBucket: "happyasciicat.appspot.com",
// 	messagingSenderId: "883683372838",
// 	appId: "1:883683372838:web:923e53ef20ec7ab4a81be7",
// 	measurementId: "G-B2WEVKTV3F"
// };
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, analytics, storage };